import { z } from 'zod';

export const userManagementSchema = z.object({
  teams: z.array(z.string()),
  profiles: z.array(z.string()),
  allow_create: z.boolean(),
  allow_delete: z.boolean(),
});

type userManagementSchemaType = z.infer<typeof userManagementSchema>;

const defaultValue: userManagementSchemaType = {
  allow_create: true,
  allow_delete: true,
  profiles: [],
  teams: [],
};

export const userManagementDefaultValue = JSON.stringify(defaultValue, null, '\t');
